import { Component, ContentChild, Input, Host, Inject, forwardRef, OnChanges } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

import { EuiTabContentComponent } from '../eui-tab-content/eui-tab-content.component';
import { EuiTabLabelComponent } from '../eui-tab-label/eui-tab-label.component';
import { EuiTabsComponent } from '../eui-tabs.component';
import { BaseDirective } from '../../../base.directive';

@Component({
    selector: 'eui-tab',
    templateUrl: './eui-tab.component.html',
    styleUrls: ['../styles/_index.scss'],
})
export class EuiTabComponent extends BaseDirective implements OnChanges {
    @Input()
    get isClosable() { return this._isClosable; }
    set isClosable(value) { this._isClosable = coerceBooleanProperty(value); }
    _isClosable = false;
    @Input() url: string;
    @Input() e2eAttr = 'eui-tab';
    @Input()
    get isVisible() { return this._isVisible; }
    set isVisible(value) { this._isVisible = coerceBooleanProperty(value); }
    _isVisible = true;
    @Input()
    get isActive() { return this._isActive; }
    set isActive(value) { this._isActive = coerceBooleanProperty(value); }
    _isActive = false;
    @Input()
    get isDisabled() { return this._isDisabled; }
    set isDisabled(value) { this._isDisabled = coerceBooleanProperty(value); }
    _isDisabled = false;
    @Input()
    get hasBackgroundFilled() { return this._hasBackgroundFilled; }
    set hasBackgroundFilled(value) { this._hasBackgroundFilled = coerceBooleanProperty(value); }
    _hasBackgroundFilled = false;
    @Input() tooltip: string;

    @ContentChild(EuiTabLabelComponent)
    get templateLabel(): EuiTabLabelComponent { return this._templateLabel; }
    set templateLabel(value: EuiTabLabelComponent) { this.setTemplateLabelInput(value); }
    protected _templateLabel: EuiTabLabelComponent;

    @ContentChild(EuiTabContentComponent)
    get templateContent(): EuiTabContentComponent { return this._templateContent; }
    set templateContent(value: EuiTabContentComponent) { this.setTemplateContentInput(value); }
    protected _templateContent: EuiTabContentComponent;

    constructor(@Host() @Inject(forwardRef(() => EuiTabsComponent)) private euiTabsComponent: EuiTabsComponent) {
        super();
    }

    ngOnChanges(): void {
        this.euiTabsComponent.detectChanges();
    }

    protected setTemplateLabelInput(value: EuiTabLabelComponent): void {
        if (value) {
            this._templateLabel = value;
        }
    }

    protected setTemplateContentInput(value: EuiTabContentComponent): void {
        if (value) {
            this._templateContent = value;
        }
    }
}
